var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _onBreakpointChange, _FacetsFormComponent_instances, getSearchQuery_fn, updateURLHash_fn, updateSection_fn, dispatchSearchUpdateEvent_fn, getResultsCount_fn, dispatchCollectionUpdateEvent_fn, _FacetInputsComponent_instances, prefetchOption_fn, updateSelectedFacetSummary_fn, _PriceFacetComponent_instances, extractMoneyPlaceholder_fn, _onKeyDown, parseDisplayValue_fn, adjustToValidValues_fn, setMinAndMaxValues_fn, updateSummary_fn, _handleFilterUpdate, _handleFilterUpdate2, _SortingFilterComponent_instances, moveFocus_fn, selectOption_fn, closeDropdown_fn, _FacetStatusComponent_instances, updateSwatchSummary_fn, updateBubbleSummary_fn, parseCents_fn, formatMoney_fn;
import { sectionRenderer } from "@theme/section-renderer";
import { Component } from "@theme/component";
import { debounce, mediaQueryLarge, startViewTransition } from "@theme/utilities";
import { convertMoneyToMinorUnits, formatMoney } from "@theme/money-formatting";
import { CollectionUpdateEvent, SearchUpdateEvent, StandardEvents } from "@shopify/events";
const SEARCH_QUERY = "q";
const filterRequests = /* @__PURE__ */ new WeakMap();
function preserveSearchScope(parameters, current) {
  for (const key of ["type", "options[prefix]", "options[unavailable_products]"]) {
    if (!parameters.has(key) && current.has(key)) parameters.set(key, current.get(key));
  }
}
class FacetsFormComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _FacetsFormComponent_instances);
    __publicField(this, "requiredRefs", ["facetsForm"]);
    __publicField(this, "restoreFiltersFromHistory", () => {
      const section = this.closest(".shopify-section");
      if (!this.isConnected || !section || section.querySelector("facets-form-component") !== this) return;
      const renderPromise = __privateMethod(this, _FacetsFormComponent_instances, updateSection_fn).call(this);
      if (this.dataset.pageType === "search") {
        __privateMethod(this, _FacetsFormComponent_instances, dispatchSearchUpdateEvent_fn).call(this, renderPromise);
      } else {
        __privateMethod(this, _FacetsFormComponent_instances, dispatchCollectionUpdateEvent_fn).call(this, renderPromise);
      }
    });
    __privateAdd(this, _onBreakpointChange, (event) => {
      if (!event.matches) return;
      const drawer = document.getElementById("filters-drawer");
      if (drawer && "close" in drawer && typeof drawer.close === "function") {
        drawer.close();
      }
    });
    __publicField(this, "updateFilters", () => {
      __privateMethod(this, _FacetsFormComponent_instances, updateURLHash_fn).call(this);
      const renderPromise = __privateMethod(this, _FacetsFormComponent_instances, updateSection_fn).call(this);
      if (this.dataset.pageType === "search") {
        __privateMethod(this, _FacetsFormComponent_instances, dispatchSearchUpdateEvent_fn).call(this, renderPromise);
      } else {
        __privateMethod(this, _FacetsFormComponent_instances, dispatchCollectionUpdateEvent_fn).call(this, renderPromise);
      }
    });
  }
  connectedCallback() {
    super.connectedCallback();
    window.addEventListener("popstate", this.restoreFiltersFromHistory);
    if (this.dataset.filterStyle === "vertical") {
      mediaQueryLarge.addEventListener("change", __privateGet(this, _onBreakpointChange));
    }
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener("popstate", this.restoreFiltersFromHistory);
    mediaQueryLarge.removeEventListener("change", __privateGet(this, _onBreakpointChange));
  }
  /**
   * Creates URL parameters from form data
   * @param {FormData} [formData] - Optional form data to use instead of the main form
   * @returns {URLSearchParams} The processed URL parameters
   */
  createURLParameters(formData = new FormData(this.refs.facetsForm)) {
    let newParameters = new URLSearchParams(
      /** @type any */
      formData
    );
    if (newParameters.get("filter.v.price.gte") === "") newParameters.delete("filter.v.price.gte");
    if (newParameters.get("filter.v.price.lte") === "") newParameters.delete("filter.v.price.lte");
    newParameters.delete("page");
    // Mobile select and hidden desktop radios can submit the same sort twice.
    if (newParameters.has("sort_by")) newParameters.set("sort_by", newParameters.get("sort_by"));
    const currentParameters = new URL(window.location.href).searchParams;
    if (this.dataset.pageType === "search") preserveSearchScope(newParameters, currentParameters);
    const toyView = currentParameters.get("view");
    if (toyView == null ? void 0 : toyView.startsWith("pb-toys-")) newParameters.set("view", toyView);
    const searchQuery = __privateMethod(this, _FacetsFormComponent_instances, getSearchQuery_fn).call(this);
    if (searchQuery) newParameters.set(SEARCH_QUERY, searchQuery);
    return newParameters;
  }
  get sectionId() {
    const id = this.getAttribute("section-id");
    if (!id) throw new Error("Section ID is required");
    return id;
  }
  /**
   * Updates filters based on a provided URL
   * @param {string} url - The URL to update filters with
   */
  updateFiltersByURL(url) {
    const destination = new URL(url, window.location.href);
    const current = new URL(window.location.href);
    if (this.dataset.pageType === "search" && destination.pathname === current.pathname) {
      preserveSearchScope(destination.searchParams, current.searchParams);
    }
    const toyView = current.searchParams.get("view");
    if (toyView == null ? void 0 : toyView.startsWith("pb-toys-")) destination.searchParams.set("view", toyView);
    history.pushState("", "", destination);
    const renderPromise = __privateMethod(this, _FacetsFormComponent_instances, updateSection_fn).call(this);
    if (this.dataset.pageType === "search") {
      __privateMethod(this, _FacetsFormComponent_instances, dispatchSearchUpdateEvent_fn).call(this, renderPromise);
    } else {
      __privateMethod(this, _FacetsFormComponent_instances, dispatchCollectionUpdateEvent_fn).call(this, renderPromise);
    }
  }
}
_onBreakpointChange = /* @__PURE__ */ new WeakMap();
_FacetsFormComponent_instances = /* @__PURE__ */ new WeakSet();
getSearchQuery_fn = function() {
  var _a;
  const url = new URL(window.location.href);
  return (_a = url.searchParams.get(SEARCH_QUERY)) != null ? _a : "";
};
updateURLHash_fn = function() {
  const url = new URL(window.location.href);
  const urlParameters = this.createURLParameters();
  url.search = "";
  for (const [param, value] of urlParameters.entries()) {
    url.searchParams.append(param, value);
  }
  history.pushState({ urlParameters: urlParameters.toString() }, "", url.toString());
};
updateSection_fn = function() {
  const section = this.closest(".shopify-section");
  const destination = window.location.href;
  const request = {};
  if (section) {
    filterRequests.set(section, request);
    const message = section.querySelector("[data-filter-error]");
    if (message) message.hidden = true;
  }
  const isCurrent = () => this.isConnected && (!section || filterRequests.get(section) === request) && window.location.href === destination;
  let updatePromise;
  const render = () => {
    if (!updatePromise) updatePromise = (async () => {
      if (!isCurrent()) throw new DOMException("Superseded filter request", "AbortError");
      await sectionRenderer.renderSection(this.sectionId, { url: new URL(destination) });
      if (isCurrent() && section && this.dataset.pageType === "search") {
        const results = section.querySelector("[data-search-page-title]");
        const title = results && results.getAttribute("data-search-page-title");
        if (title && title.trim()) document.title = title.trim();
      }
    })();
    return updatePromise;
  };
  const renderPromise = this.closest("dialog") ? render() : startViewTransition(render, ["product-grid"]);
  return Promise.resolve(renderPromise).catch(async (error) => {
    if (updatePromise) {
      try {
        await updatePromise;
        return;
      } catch (renderError) {
        error = renderError;
      }
    }
    if (section && isCurrent()) {
      const message = section.querySelector("[data-filter-error]");
      const link = message && message.querySelector("a");
      if (message && link) {
        link.href = destination;
        message.hidden = false;
        const drawer = this.closest("theme-drawer");
        if (drawer && typeof drawer.close === "function") await drawer.close();
        if (isCurrent() && !message.hidden) link.focus();
      }
    }
    throw error;
  });
};
dispatchSearchUpdateEvent_fn = function(renderPromise) {
  const query = __privateMethod(this, _FacetsFormComponent_instances, getSearchQuery_fn).call(this);
  const deferredPromise = SearchUpdateEvent.createPromise();
  deferredPromise.promise.catch(() => {
  });
  const productFilters = SearchUpdateEvent.parseProductFilters();
  this.dispatchEvent(
    new SearchUpdateEvent({
      search: {
        query,
        ...productFilters && { productFilters },
        sortKey: SearchUpdateEvent.getSortKey()
      },
      promise: deferredPromise.promise
    })
  );
  renderPromise.then(() => deferredPromise.resolve({ totalCount: __privateMethod(this, _FacetsFormComponent_instances, getResultsCount_fn).call(this) })).catch((error) => deferredPromise.reject(error));
};
getResultsCount_fn = function() {
  return Number(this.dataset.resultsCount) || 0;
};
dispatchCollectionUpdateEvent_fn = function(renderPromise) {
  const rawId = this.dataset.collectionId;
  const collectionData = {
    id: rawId && /^\d+$/.test(rawId) ? rawId : null,
    handle: (
      /** @type {string} */
      this.dataset.collectionHandle
    ),
    productsCount: __privateMethod(this, _FacetsFormComponent_instances, getResultsCount_fn).call(this)
  };
  const deferredPromise = CollectionUpdateEvent.createPromise();
  deferredPromise.promise.catch(() => {
  });
  const productFilters = CollectionUpdateEvent.parseProductFilters();
  this.dispatchEvent(
    new CollectionUpdateEvent({
      collection: collectionData,
      ...productFilters && { productFilters },
      sortKey: CollectionUpdateEvent.getSortKey(),
      promise: deferredPromise.promise
    })
  );
  renderPromise.then(() => deferredPromise.resolve({ productsCount: __privateMethod(this, _FacetsFormComponent_instances, getResultsCount_fn).call(this) })).catch((error) => deferredPromise.reject(error));
};
if (!customElements.get("facets-form-component")) {
  customElements.define("facets-form-component", FacetsFormComponent);
}
class FacetInputsComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _FacetInputsComponent_instances);
    __publicField(this, "prefetchPage", debounce((event) => {
      if (!(event.target instanceof HTMLElement)) return;
      __privateMethod(this, _FacetInputsComponent_instances, prefetchOption_fn).call(this, event.target);
    }, 200));
    __publicField(this, "cancelPrefetchPage", () => this.prefetchPage.cancel());
  }
  get sectionId() {
    var _a;
    const id = (_a = this.closest(".shopify-section")) == null ? void 0 : _a.id;
    if (!id) throw new Error("FacetInputs component must be a child of a section");
    return id;
  }
  /**
   * Updates filters and the selected facet summary
   */
  updateFilters() {
    const facetsForm = this.closest("facets-form-component");
    if (!(facetsForm instanceof FacetsFormComponent)) return;
    facetsForm.updateFilters();
    __privateMethod(this, _FacetInputsComponent_instances, updateSelectedFacetSummary_fn).call(this);
  }
  /**
   * Handles keydown events for the facets form
   * @param {KeyboardEvent} event - The keydown event
   */
  handleKeyDown(event) {
    if (!(event.target instanceof HTMLElement)) return;
    if (event.repeat || event.metaKey || event.ctrlKey || event.altKey) return;
    if (event.target instanceof HTMLInputElement && event.key === " ") return;
    const label = event.target.closest("label");
    const closestInput = event.target instanceof HTMLInputElement ? event.target : label && label.control || event.target.querySelector("input");
    if (!(closestInput instanceof HTMLInputElement) || closestInput.type !== "checkbox" || closestInput.disabled || !this.contains(closestInput)) return;
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      closestInput.checked = !closestInput.checked;
      this.updateFilters();
    }
  }
  /**
   * Fires immediately on pointerdown so a quick tap triggers the prefetch.
   * @param {PointerEvent} event
   */
  prefetchPageImmediate(event) {
    if (!(event.target instanceof HTMLElement)) return;
    __privateMethod(this, _FacetInputsComponent_instances, prefetchOption_fn).call(this, event.target);
  }
}
_FacetInputsComponent_instances = /* @__PURE__ */ new WeakSet();
prefetchOption_fn = function(optionElement) {
  const form = this.closest("form");
  if (!form) return;
  const inputElement = optionElement.querySelector("input");
  if (!(inputElement instanceof HTMLInputElement) || inputElement.disabled) return;
  const facetsForm = this.closest("facets-form-component");
  if (!(facetsForm instanceof FacetsFormComponent)) return;
  const formData = new FormData(form);
  if (!inputElement.checked) formData.append(inputElement.name, inputElement.value);
  const urlParameters = facetsForm.createURLParameters(formData);
  const url = new URL(window.location.pathname, window.location.origin);
  for (const [key, value] of urlParameters) url.searchParams.append(key, value);
  if (inputElement.checked) url.searchParams.delete(inputElement.name, inputElement.value);
  sectionRenderer.getSectionHTML(this.sectionId, true, url);
};
updateSelectedFacetSummary_fn = function() {
  if (!this.refs.facetInputs) return;
  const checkedInputElements = this.refs.facetInputs.filter((input) => input.checked);
  const details = this.closest("details");
  const statusComponent = details == null ? void 0 : details.querySelector("facet-status-component");
  if (!(statusComponent instanceof FacetStatusComponent)) return;
  statusComponent.updateListSummary(checkedInputElements);
};
if (!customElements.get("facet-inputs-component")) {
  customElements.define("facet-inputs-component", FacetInputsComponent);
}
class PriceFacetComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _PriceFacetComponent_instances);
    __publicField(this, "currency");
    __publicField(this, "moneyFormat");
    __privateAdd(this, _onKeyDown, (event) => {
      if (event.metaKey) return;
      const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
      if (!event.key.match(pattern)) event.preventDefault();
    });
  }
  connectedCallback() {
    var _a, _b;
    super.connectedCallback();
    this.addEventListener("keydown", __privateGet(this, _onKeyDown));
    this.currency = (_a = this.dataset.currency) != null ? _a : "USD";
    this.moneyFormat = __privateMethod(this, _PriceFacetComponent_instances, extractMoneyPlaceholder_fn).call(this, (_b = this.dataset.moneyFormat) != null ? _b : "{{amount}}");
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener("keydown", __privateGet(this, _onKeyDown));
  }
  /**
   * Updates price filter and results
   */
  updatePriceFilterAndResults() {
    const { minInput, maxInput } = this.refs;
    __privateMethod(this, _PriceFacetComponent_instances, adjustToValidValues_fn).call(this, minInput);
    __privateMethod(this, _PriceFacetComponent_instances, adjustToValidValues_fn).call(this, maxInput);
    const facetsForm = this.closest("facets-form-component");
    if (!(facetsForm instanceof FacetsFormComponent)) return;
    facetsForm.updateFilters();
    __privateMethod(this, _PriceFacetComponent_instances, setMinAndMaxValues_fn).call(this);
    __privateMethod(this, _PriceFacetComponent_instances, updateSummary_fn).call(this);
  }
}
_PriceFacetComponent_instances = /* @__PURE__ */ new WeakSet();
extractMoneyPlaceholder_fn = function(format) {
  const match = format.match(/{{\s*\w+\s*}}/);
  return match ? match[0] : "{{amount}}";
};
_onKeyDown = /* @__PURE__ */ new WeakMap();
parseDisplayValue_fn = function(displayValue, currency) {
  var _a;
  return (_a = convertMoneyToMinorUnits(displayValue, currency)) != null ? _a : 0;
};
adjustToValidValues_fn = function(input) {
  var _a, _b;
  if (input.value.trim() === "") return;
  const { currency, moneyFormat } = this;
  const value = __privateMethod(this, _PriceFacetComponent_instances, parseDisplayValue_fn).call(this, input.value, currency);
  const min = __privateMethod(this, _PriceFacetComponent_instances, parseDisplayValue_fn).call(this, (_a = input.getAttribute("data-min")) != null ? _a : "0", currency);
  const max = __privateMethod(this, _PriceFacetComponent_instances, parseDisplayValue_fn).call(this, (_b = input.getAttribute("data-max")) != null ? _b : "0", currency);
  if (value < min) {
    input.value = formatMoney(min, moneyFormat, currency);
  } else if (value > max) {
    input.value = formatMoney(max, moneyFormat, currency);
  }
};
setMinAndMaxValues_fn = function() {
  var _a;
  const { minInput, maxInput } = this.refs;
  if (maxInput.value) minInput.setAttribute("data-max", maxInput.value);
  if (minInput.value) maxInput.setAttribute("data-min", minInput.value);
  if (minInput.value === "") maxInput.setAttribute("data-min", "0");
  if (maxInput.value === "") minInput.setAttribute("data-max", (_a = maxInput.getAttribute("data-max")) != null ? _a : "");
};
updateSummary_fn = function() {
  const { minInput, maxInput } = this.refs;
  const details = this.closest("details");
  const statusComponent = details == null ? void 0 : details.querySelector("facet-status-component");
  if (!(statusComponent instanceof FacetStatusComponent)) return;
  statusComponent == null ? void 0 : statusComponent.updatePriceSummary(minInput, maxInput);
};
if (!customElements.get("price-facet-component")) {
  customElements.define("price-facet-component", PriceFacetComponent);
}
class FacetClearComponent extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "requiredRefs", ["clearButton"]);
    __privateAdd(this, _handleFilterUpdate, (event) => {
      var _a, _b, _c, _d;
      const eventSection = (
        /** @type {Element | null} */
        (_a = event.target) == null ? void 0 : _a.closest(".shopify-section")
      );
      const mySection = this.closest(".shopify-section");
      if (eventSection && mySection && eventSection !== mySection) return;
      const { clearButton } = this.refs;
      if (clearButton instanceof Element) {
        const filters = event instanceof SearchUpdateEvent ? (_c = (_b = event.search) == null ? void 0 : _b.productFilters) != null ? _c : [] : (_d = event.productFilters) != null ? _d : [];
        clearButton.classList.toggle("facets__clear--active", filters.length > 0);
      }
    });
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(StandardEvents.searchUpdate, __privateGet(this, _handleFilterUpdate));
    document.addEventListener(StandardEvents.collectionUpdate, __privateGet(this, _handleFilterUpdate));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(StandardEvents.searchUpdate, __privateGet(this, _handleFilterUpdate));
    document.removeEventListener(StandardEvents.collectionUpdate, __privateGet(this, _handleFilterUpdate));
  }
  /**
   * Clears the filter
   * @param {Event} event - The click event
   */
  clearFilter(event) {
    if (!(event.target instanceof HTMLElement)) return;
    if (event instanceof KeyboardEvent) {
      if (event.repeat || event.metaKey || event.ctrlKey || event.altKey) return;
      if (event.key !== "Enter" && event.key !== " ") {
        return;
      }
      event.preventDefault();
    }
    const container = event.target.closest("facet-inputs-component, price-facet-component");
    container == null ? void 0 : container.querySelectorAll("input").forEach((input) => {
      if (input instanceof HTMLInputElement) {
        if (input.type === "checkbox" || input.type === "radio") {
          input.checked = false;
        } else if (input.name === "filter.v.price.gte" || input.name === "filter.v.price.lte") {
          input.value = "";
        }
      }
    });
    if (container instanceof PriceFacetComponent) {
      container.updatePriceFilterAndResults();
      return;
    }
    const details = event.target.closest("details");
    const statusComponent = details == null ? void 0 : details.querySelector("facet-status-component");
    if (statusComponent instanceof FacetStatusComponent) statusComponent.clearSummary();
    const facetsForm = this.closest("facets-form-component");
    if (!(facetsForm instanceof FacetsFormComponent)) return;
    facetsForm.updateFilters();
  }
}
_handleFilterUpdate = /* @__PURE__ */ new WeakMap();
if (!customElements.get("facet-clear-component")) {
  customElements.define("facet-clear-component", FacetClearComponent);
}
class FacetRemoveComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _handleFilterUpdate2, (event) => {
      var _a, _b, _c, _d;
      const eventSection = (
        /** @type {Element | null} */
        (_a = event.target) == null ? void 0 : _a.closest(".shopify-section")
      );
      const mySection = this.closest(".shopify-section");
      if (eventSection && mySection && eventSection !== mySection) return;
      const { clearButton } = this.refs;
      if (clearButton instanceof Element) {
        const activeClass = this.getAttribute("active-class") || "active";
        const filters = event instanceof SearchUpdateEvent ? (_c = (_b = event.search) == null ? void 0 : _b.productFilters) != null ? _c : [] : (_d = event.productFilters) != null ? _d : [];
        clearButton.classList.toggle(activeClass, filters.length > 0);
      }
    });
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(StandardEvents.searchUpdate, __privateGet(this, _handleFilterUpdate2));
    document.addEventListener(StandardEvents.collectionUpdate, __privateGet(this, _handleFilterUpdate2));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(StandardEvents.searchUpdate, __privateGet(this, _handleFilterUpdate2));
    document.removeEventListener(StandardEvents.collectionUpdate, __privateGet(this, _handleFilterUpdate2));
  }
  /**
   * Removes the filter
   * @param {Object} data - The data object
   * @param {string} data.form - The form to remove the filter from
   * @param {Event} event - The click event
   */
  removeFilter({ form }, event) {
    if (event instanceof KeyboardEvent) {
      if (event.key !== "Enter" && event.key !== " ") {
        return;
      }
      event.preventDefault();
    }
    const url = this.dataset.url;
    if (!url) return;
    const facetsForm = form ? document.getElementById(form) : this.closest("facets-form-component");
    if (!(facetsForm instanceof FacetsFormComponent)) return;
    facetsForm.updateFiltersByURL(url);
  }
}
_handleFilterUpdate2 = /* @__PURE__ */ new WeakMap();
if (!customElements.get("facet-remove-component")) {
  customElements.define("facet-remove-component", FacetRemoveComponent);
}
class SortingFilterComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _SortingFilterComponent_instances);
    __publicField(this, "requiredRefs", ["details", "summary", "listbox"]);
    __publicField(this, "handleKeyDown", (event) => {
      const { listbox } = this.refs;
      if (!(listbox instanceof Element)) return;
      const options = Array.from(listbox.querySelectorAll('[role="option"]'));
      const currentFocused = options.find((option) => option instanceof HTMLElement && option.tabIndex === 0);
      let newFocusIndex = currentFocused ? options.indexOf(currentFocused) : 0;
      switch (event.key) {
        case "ArrowDown":
          event.preventDefault();
          newFocusIndex = Math.min(newFocusIndex + 1, options.length - 1);
          __privateMethod(this, _SortingFilterComponent_instances, moveFocus_fn).call(this, options, newFocusIndex);
          break;
        case "ArrowUp":
          event.preventDefault();
          newFocusIndex = Math.max(newFocusIndex - 1, 0);
          __privateMethod(this, _SortingFilterComponent_instances, moveFocus_fn).call(this, options, newFocusIndex);
          break;
        case "Enter":
        case " ":
          if (event.target instanceof Element) {
            const targetOption = event.target.closest('[role="option"]');
            if (targetOption) {
              event.preventDefault();
              __privateMethod(this, _SortingFilterComponent_instances, selectOption_fn).call(this, targetOption);
            }
          }
          break;
        case "Escape":
          event.preventDefault();
          __privateMethod(this, _SortingFilterComponent_instances, closeDropdown_fn).call(this);
          break;
      }
    });
    __publicField(this, "handleToggle", () => {
      const { details, summary, listbox } = this.refs;
      if (!(details instanceof HTMLDetailsElement) || !(summary instanceof HTMLElement)) return;
      const isOpen = details.open;
      summary.setAttribute("aria-expanded", isOpen.toString());
      if (isOpen && listbox instanceof Element) {
        const selectedOption = listbox.querySelector('[aria-selected="true"]');
        if (selectedOption instanceof HTMLElement) {
          selectedOption.focus();
        }
      }
    });
  }
  /**
   * Updates filter and sorting
   * @param {Event} event - The change event
   */
  updateFilterAndSorting(event) {
    var _a;
    const facetsForm = this.closest("facets-form-component") || ((_a = this.closest(".shopify-section")) == null ? void 0 : _a.querySelector("facets-form-component"));
    if (!(facetsForm instanceof FacetsFormComponent)) return;
    const isMobile = window.innerWidth < 750;
    const shouldDisable = this.dataset.shouldUseSelectOnMobile === "true";
    if (shouldDisable) {
      if (isMobile) {
        const inputs = this.querySelectorAll('input[name="sort_by"]');
        inputs.forEach((input) => {
          if (!(input instanceof HTMLInputElement)) return;
          input.disabled = true;
        });
      } else {
        const selectElement = this.querySelector('select[name="sort_by"]');
        if (!(selectElement instanceof HTMLSelectElement)) return;
        selectElement.disabled = true;
      }
    }
    facetsForm.updateFilters();
    this.updateFacetStatus(event);
    if (shouldDisable) {
      if (isMobile) {
        const inputs = this.querySelectorAll('input[name="sort_by"]');
        inputs.forEach((input) => {
          if (!(input instanceof HTMLInputElement)) return;
          input.disabled = false;
        });
      } else {
        const selectElement = this.querySelector('select[name="sort_by"]');
        if (!(selectElement instanceof HTMLSelectElement)) return;
        selectElement.disabled = false;
      }
    }
    const { details } = this.refs;
    if (!(details instanceof HTMLDetailsElement)) return;
    details.open = false;
  }
  /**
   * Updates the facet status
   * @param {Event} event - The change event
   */
  updateFacetStatus(event) {
    var _a;
    if (!(event.target instanceof HTMLSelectElement)) return;
    const details = this.querySelector("details");
    if (!details) return;
    const facetStatus = details.querySelector("facet-status-component");
    if (!(facetStatus instanceof FacetStatusComponent)) return;
    facetStatus.textContent = event.target.value !== details.dataset.defaultSortBy ? (_a = event.target.dataset.optionName) != null ? _a : "" : "";
  }
}
_SortingFilterComponent_instances = /* @__PURE__ */ new WeakSet();
moveFocus_fn = function(options, newIndex) {
  options.forEach((option) => {
    if (option instanceof HTMLElement) {
      option.tabIndex = -1;
    }
  });
  const targetOption = options[newIndex];
  if (targetOption instanceof HTMLElement) {
    targetOption.tabIndex = 0;
    targetOption.focus();
  }
};
selectOption_fn = function(option) {
  const input = option.querySelector('input[type="radio"]');
  if (input instanceof HTMLInputElement && option instanceof HTMLElement) {
    this.querySelectorAll('[role="option"]').forEach((opt) => {
      opt.setAttribute("aria-selected", "false");
    });
    option.setAttribute("aria-selected", "true");
    input.click();
    __privateMethod(this, _SortingFilterComponent_instances, closeDropdown_fn).call(this);
  }
};
closeDropdown_fn = function() {
  const { details, summary } = this.refs;
  if (details instanceof HTMLDetailsElement) {
    const options = this.querySelectorAll('[role="option"]');
    const selectedOption = this.querySelector('[aria-selected="true"]');
    options.forEach((opt) => {
      if (opt instanceof HTMLElement) {
        opt.tabIndex = -1;
      }
    });
    if (selectedOption instanceof HTMLElement) {
      selectedOption.tabIndex = 0;
    }
    details.open = false;
    if (summary instanceof HTMLElement) {
      summary.focus();
    }
  }
};
if (!customElements.get("sorting-filter-component")) {
  customElements.define("sorting-filter-component", SortingFilterComponent);
}
class FacetStatusComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _FacetStatusComponent_instances);
  }
  /**
   * Updates the list summary
   * @param {HTMLInputElement[]} checkedInputElements - The checked input elements
   */
  updateListSummary(checkedInputElements) {
    const checkedInputElementsCount = checkedInputElements.length;
    this.getAttribute("facet-type") === "swatches" ? __privateMethod(this, _FacetStatusComponent_instances, updateSwatchSummary_fn).call(this, checkedInputElements, checkedInputElementsCount) : __privateMethod(this, _FacetStatusComponent_instances, updateBubbleSummary_fn).call(this, checkedInputElements, checkedInputElementsCount);
  }
  /**
   * Updates the price summary
   * @param {HTMLInputElement} minInput - The minimum price input
   * @param {HTMLInputElement} maxInput - The maximum price input
   */
  updatePriceSummary(minInput, maxInput) {
    const minInputValue = minInput.value;
    const maxInputValue = maxInput.value;
    const { facetStatus } = this.refs;
    if (!minInputValue && !maxInputValue) {
      facetStatus.innerHTML = "";
      return;
    }
    const currency = facetStatus.dataset.currency || "";
    const minInputNum = __privateMethod(this, _FacetStatusComponent_instances, parseCents_fn).call(this, minInputValue, "0", currency);
    const maxInputNum = __privateMethod(this, _FacetStatusComponent_instances, parseCents_fn).call(this, maxInputValue, facetStatus.dataset.rangeMax, currency);
    facetStatus.innerHTML = "".concat(__privateMethod(this, _FacetStatusComponent_instances, formatMoney_fn).call(this, minInputNum), "\u2013").concat(__privateMethod(this, _FacetStatusComponent_instances, formatMoney_fn).call(this, maxInputNum));
  }
  /**
   * Clears the summary
   */
  clearSummary() {
    this.refs.facetStatus.innerHTML = "";
  }
}
_FacetStatusComponent_instances = /* @__PURE__ */ new WeakSet();
updateSwatchSummary_fn = function(checkedInputElements, checkedInputElementsCount) {
  const { facetStatus } = this.refs;
  facetStatus.classList.remove("bubble", "facets__bubble");
  if (checkedInputElementsCount === 0) {
    facetStatus.innerHTML = "";
    return;
  }
  if (checkedInputElementsCount > 3) {
    facetStatus.innerHTML = checkedInputElementsCount.toString();
    facetStatus.classList.add("bubble", "facets__bubble");
    return;
  }
  facetStatus.innerHTML = Array.from(checkedInputElements).map((inputElement) => {
    var _a, _b, _c;
    const swatch = (_a = inputElement.parentElement) == null ? void 0 : _a.querySelector("span.swatch");
    const span = document.createElement("span");
    span.className = "visually-hidden";
    span.textContent = (_b = inputElement.getAttribute("aria-label")) != null ? _b : "";
    return ((_c = swatch == null ? void 0 : swatch.outerHTML) != null ? _c : "") + span.outerHTML;
  }).join("");
};
updateBubbleSummary_fn = function(checkedInputElements, checkedInputElementsCount) {
  var _a, _b;
  const { facetStatus } = this.refs;
  const filterStyle = this.dataset.filterStyle;
  facetStatus.classList.remove("bubble", "facets__bubble");
  if (checkedInputElementsCount === 0) {
    facetStatus.innerHTML = "";
    return;
  }
  if (filterStyle === "horizontal" && checkedInputElementsCount === 1) {
    facetStatus.textContent = (_b = (_a = checkedInputElements[0]) == null ? void 0 : _a.dataset.label) != null ? _b : "";
    return;
  }
  facetStatus.innerHTML = checkedInputElementsCount.toString();
  facetStatus.classList.add("bubble", "facets__bubble");
};
parseCents_fn = function(value, fallback = "0", currency = "") {
  const result = convertMoneyToMinorUnits(value, currency);
  if (result !== null) return result;
  const fallbackResult = convertMoneyToMinorUnits(fallback, currency);
  if (fallbackResult !== null) return fallbackResult;
  const cleanFallback = fallback.replace(/[^\d]/g, "");
  return parseInt(cleanFallback, 10) || 0;
};
formatMoney_fn = function(moneyValue) {
  if (!(this.refs.moneyFormat instanceof HTMLTemplateElement)) return "";
  const format = this.refs.moneyFormat.content.textContent || "{{amount}}";
  const currency = this.refs.facetStatus.dataset.currency || "";
  return formatMoney(moneyValue, format, currency);
};
if (!customElements.get("facet-status-component")) {
  customElements.define("facet-status-component", FacetStatusComponent);
}
